"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isoWeekSchema = exports.isoYearSchema = exports.leistungsphaseSchema = exports.timestampSchema = exports.dateSchema = exports.percentageSchema = exports.moneySchema = exports.hoursSchema = exports.textSchema = exports.uuidSchema = exports.idSchema = void 0;
exports.isValidIsoWeek = isValidIsoWeek;
const zod_1 = require("zod");
/** Identifiers are opaque; demo prefixes such as WP-04 are not a production format. */
exports.idSchema = zod_1.z.string().trim().min(1);
/**
 * Eine UUID, auf Kleinbuchstaben normalisiert — die EINZIGE Stelle dafür.
 *
 * `z.uuid()` nimmt Grossbuchstaben an, PostgreSQL liefert eine UUID aber immer
 * klein. Jeder Vergleich als Zeichenkette dahinter (Selbstschutzregel,
 * „gleiches Ziel", `Set`, `find`) ginge an einer gross geschriebenen Eingabe
 * vorbei (Befunde aus den Reviews zu PR #51 und AC-505). Ein rohes `z.uuid()`
 * ist deshalb per Lint-Regel verboten (AC-000).
 */
exports.uuidSchema = zod_1.z.uuid().transform((wert) => wert.toLowerCase());
exports.textSchema = zod_1.z.string().trim().min(1);
exports.hoursSchema = zod_1.z.number().finite().nonnegative();
exports.moneySchema = zod_1.z.number().finite().nonnegative();
exports.percentageSchema = zod_1.z.number().finite().min(0).max(100);
exports.dateSchema = zod_1.z.iso.date();
exports.timestampSchema = zod_1.z.iso.datetime({ offset: true });
exports.leistungsphaseSchema = zod_1.z.number().int().min(1).max(9);
exports.isoYearSchema = zod_1.z.number().int().min(1).max(9999);
exports.isoWeekSchema = zod_1.z.number().int().min(1).max(53);
/** An ISO year has week 53 only if it starts on Thursday, or on Wednesday in a leap year. */
function isValidIsoWeek({ isoYear, isoWeek, }) {
    if (!Number.isInteger(isoYear) || isoYear < 1 || isoYear > 9999)
        return false;
    if (!Number.isInteger(isoWeek) || isoWeek < 1 || isoWeek > 53)
        return false;
    const januaryFirst = new Date(0);
    januaryFirst.setUTCFullYear(isoYear, 0, 1);
    const weekday = januaryFirst.getUTCDay();
    const leapYear = isoYear % 4 === 0 && (isoYear % 100 !== 0 || isoYear % 400 === 0);
    return isoWeek <= (weekday === 4 || (weekday === 3 && leapYear) ? 53 : 52);
}
//# sourceMappingURL=common.js.map